import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, InfinityIcon, RefreshCwIcon, CreditCardIcon, TrendingUpIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CtaButton, CHECKOUT_URL } from './CtaButton';
import { PRICE, TOTAL_VALUE } from './data';
const includes = [{
  icon: CreditCardIcon,
  text: 'Un solo pago'
}, {
  icon: InfinityIcon,
  text: 'Acceso de por vida'
}, {
  icon: RefreshCwIcon,
  text: 'Actualizaciones incluidas'
}];
export function PricingOffer() {
  return <section id="oferta" className="relative w-full overflow-hidden bg-ink-900 py-10 sm:py-16" data-id="element-208">
      <div className="absolute inset-0 bg-lab-grid opacity-30" aria-hidden="true" data-id="element-209" />
      <div className="absolute inset-0 bg-radial-cyan opacity-70" aria-hidden="true" data-id="element-210" />
      <div className="relative mx-auto max-w-3xl px-5 text-center" data-id="element-211">
        <Reveal data-id="element-212">
          <p className="text-base text-silver/75 sm:text-lg" data-id="element-213">
            Sabemos que esto vale cada centavo de los{' '}
            <span className="font-semibold text-white" data-id="element-214">{TOTAL_VALUE}</span>.
            Pero no queremos que el precio sea el obstáculo entre tú y tu
            próximo lanzamiento exitoso.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-215">
          <motion.div className="mt-10 rounded-[2rem] border border-accent/40 bg-gradient-to-b from-ink-800 to-ink-950 p-8 shadow-glow-cyan-lg sm:p-12" data-id="element-216">
            <span className="inline-block rounded-full border border-accent/30 bg-accent/5 px-4 py-1 text-xs font-bold uppercase tracking-widest text-accent-light" data-id="element-217">
              Por tiempo limitado — Lanzamiento Nano-Creative Labs
            </span>

            <p className="mt-6 text-sm uppercase tracking-widest text-silver/60" data-id="element-218">
              Llévatelo todo por solo
            </p>
            <div className="mt-2 flex items-end justify-center gap-3" data-id="element-219">
              <span className="font-display text-6xl tracking-tight text-cyan-gradient sm:text-7xl" data-id="element-220">
                {PRICE}
              </span>
              <span className="pb-3 text-lg font-semibold text-silver/50 line-through" data-id="element-221">
                {TOTAL_VALUE}
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-accent" data-id="element-222">
              USD
            </p>

            <p className="mx-auto mt-4 inline-flex items-center gap-2 rounded-full border border-urgency/40 bg-urgency/10 px-4 py-1.5 text-xs font-bold text-white sm:text-sm" data-id="element-223">
              <TrendingUpIcon className="h-4 w-4 text-urgency" aria-hidden="true" data-id="element-224" />
              El precio sube pronto a{' '}
              <span className="text-urgency" data-id="element-225">$97 USD</span>
            </p>

            <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-226">
              {includes.map(item => <li key={item.text} className="inline-flex items-center gap-2 text-sm text-silver/80" data-id="element-227">
                  <item.icon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-228" />
                  {item.text}
                </li>)}
            </ul>

            <div className="mt-9" data-id="element-229">
              <CtaButton href={CHECKOUT_URL} data-id="element-230" />
            </div>

            <p className="mt-5 inline-flex items-center gap-1.5 text-sm text-silver/55" data-id="element-231">
              <CheckIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-232" />
              Pago seguro · Acceso instantáneo a tu correo
            </p>
          </motion.div>
        </Reveal>
      </div>
    </section>;
}